import React from 'react';
import { Accordion } from 'react-bootstrap';

const FAQSection = () => {
  return (
    <section className="my-5 faq-section">
      <Accordion defaultActiveKey="1">
        <Accordion.Item eventKey="0">
          <Accordion.Header>Для кого ця послуга?</Accordion.Header>
          <Accordion.Body>
            <p>Послуга для батьків, які хочуть записати дитину до дитячого садка в місті Київ.</p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>Як скористатися послугою?</Accordion.Header>
          <Accordion.Body>
            <strong>Реєстрація та подача заявки</strong>
            <p>
              Зареєструйтесь на Веб-порталі надання електронних послуг Київської міської 
              державної адміністрації. Після цього вибирайте бажаний дитячий садок на сайті 
              Департаменту освіти і науки КМДА та оформте заявку...
            </p>
            {/* Остальной контент */}
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>Правове обґрунтування</Accordion.Header>
          <Accordion.Body>
            <p>Тут буде інформація про правове обґрунтування.</p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>Можливі причини відмови</Accordion.Header>
          <Accordion.Body>
            <p>Тут будуть описані можливі причини відмови.</p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header>Що відбувається після подання заяви?</Accordion.Header>
          <Accordion.Body>
            <p>Тут буде описано, що відбувається після подання заяви.</p>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </section>
  );
};

export default FAQSection;